import React from "react";
import Row from "react-bootstrap/Row";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  Heading,
  T,
  RenderTableHeader,
  ActionBtnTemplate,
} from "../components/helpful";
import { rowIndex } from "../components/utilities";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Col from "react-bootstrap/Col";
import $ from "jquery";
import { BlockUI } from "primereact/blockui";
import { Toast } from "primereact/toast";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import * as formik from "formik";
import { ErrorMessage } from "formik";
import * as yup from "yup";
import { getUser, getUsers, getRequestedUsers, getUserTypes } from "../api/api";
import { confirmDialog } from "primereact/confirmdialog";
import { Badge } from "primereact/badge";
import { Dialog } from "primereact/dialog";
import { UserSkeleton } from "../components/skeleton";
import { link } from "../config";
import { Messages } from "primereact/messages";
import { motion, AnimatePresence } from "framer-motion";

/* The Users class is a React component that manages user data, including displaying user lists,
handling user requests, and providing actions like editing and deleting users. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/
export default class Users extends React.Component {
  constructor(props) {
    super(props);
    this.actionBtnAccess = {
      edit: true,
      delete: true,
      request: true,
    };

    this.state = {
      pageTitle: <T value={"Users"} />,
      desc: <T value={"User list"} />,
      blocked: false,
      users: [],
      requestedAccount: [],
      userGroups: [],
      requestedAccountNb: 0,
      createdBy: this.props.userID,
      loading: false,
      totalRecords: 0,
      filters: null,
      globalFilterValue: "",
      accountType: null,
      datatable: 1,
      visible: false,
      userRequestData: {},
      isLoading: false,
      isSubmittingMsg: "",
      initialValues: {
        createdBy: this.props.userID,
        userID: 0,
        title: "",
        userType: 0,
        hotel: 0,
        market: 0,
        firstname: "",
        lastname: "",
        email: "",
        address: "",
        dateOfBirth: "",
        country: 0,
        company: "",
        telephone: "",
        mobile: "",
        fax: "",
        unsuscribe: true,
        isSubmitting: false,
      },
      items: [
        { name: "Available", value: 1 },
        { name: "Requested", value: 2 },
      ],
    };

    this.toggleForm = this.toggleForm.bind(this);
    this.handleLoading = this.handleLoading.bind(this);
    this.onGlobalFilterChange = this.onGlobalFilterChange.bind(this);
    this.clearFilterDatatable = this.clearFilterDatatable.bind(this);
    this.initFilters = this.initFilters.bind(this);
    this.onActionBtn = this.onActionBtn.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
    this.getUsersList = this.getUsersList.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.showStatusMsg = this.showStatusMsg.bind(this);
    this.getRequestedUsersAccount = this.getRequestedUsersAccount.bind(this);
    this.requestedUserAction = this.requestedUserAction.bind(this);
    this.handleAccountRequestOnclick = this.handleAccountRequestOnclick.bind(
      this
    );
    this.saveAccountRequest = this.saveAccountRequest.bind(this);
    this.confirmReject = this.confirmReject.bind(this);
    this.addMessages = this.addMessages.bind(this);
    this.clearMessages = this.clearMessages.bind(this);
  }

  componentDidMount() {
    this.getUsersList();
    this.getUsersGroup();
    this.getRequestedUsersAccount();
    this.initFilters();
  }

  addMessages() {
    this.msgs2.show([
      {
        severity: "success",
        summary: "Success",
        detail: "Message Content",
        sticky: true,
      },
    ]);
  }

  clearMessages() {
    this.msgs2.clear();
  }

  initFilters() {
    this.setState({
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        userCreatedDate: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        userGroup: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        userOthername: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        userSurname: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        userCountry: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
      },
      globalFilterValue: "",
    });
  }

  onGlobalFilterChange(e) {
    const value = e.target.value;
    let filters = { ...this.state.filters };
    filters["global"].value = value;
    this.setState({ filters, globalFilterValue: value });
  }
  clearFilterDatatable() {
    this.initFilters();
  }

  toggleForm(e) {
    e.preventDefault();
    $(".togglable-section").toggleClass("h");
    
    this.setState({initialValues:{
      createdBy: this.props.userID,
      userID: 0,
      title: "",
      userType: 0,
      hotel: 0,
      market: 0,
      firstname: "",
      lastname: "",
      email: "",
      address: "",
      dateOfBirth: "",
      country: 0,
      company: "",
      telephone: "",
      mobile: "",
      fax: "",
      unsuscribe: true,
      isSubmitting: false,
    }})
  }

  handleLoading() {
    this.setState({ loading: true });
  }

  handleEdit = async (e, userID) => {
    if (userID) {
      const user = await getUser(userID);

      if (user) {
        this.setState({
          initialValues: {
            createdBy: user["userCreatedBy"],
            userID: user["userID"],
            title: user["userTitle"],
            userType: user["userGroupID"],
            hotel: user["hotel"],
            market: user["userMarketdID"],
            firstname: user["userOthername"],
            lastname: user["userSurname"],
            email: user["userEmail"],
            address: user["userAddress"],
            dateOfBirth: user["userDOB"],
            country: user["userCountryID"],
            company: user["userCompany"],
            telephone: user["userPhone"],
            mobile: user["userMobile"],
            fax: user["userFax"],
            unsuscribe: user["optOutSent"],
          },
        });
      }
    }

    $(".togglable-section").toggleClass("h");
  };

  onActionBtn(data, props) {
    return (
      <>
        <ActionBtnTemplate
          itemID={data["userID"]}
          name={"User"}
          data={data}
          actionBtn={this.actionBtnAccess}
          handleEdit={this.handleEdit}
          beforeDelete={() => this.setState({ userID: data["userID"] })}
          handleDelete={this.deleteUser}
          toast={<Toast ref={(el) => (this.toast = el)} />}
        />
      </>
    );
  }

  subHeading = () => {
    return <>{this.state.desc}</>;
  };

  showStatusMsg(status, msg) {
    if (status) {
      this.toast.show({
        severity: "success",
        // summary: "Success",
        detail: msg,
        life: 3000,
        sticky: true,
      });
      // setTimeout(() => {
      //   this.toast.clear();
      // }, 3000);
    } else {
      this.toast.show({
        severity: "error",
        // summary: "Failed",
        detail: msg,
        life: 3000,
        sticky: true,
      });
    }
  }

  getUsersGroup = async () => {
    const userGroupID = this.props.userGroupID;

    if (Number(userGroupID) === 1) {
      const data = await getUserTypes(userGroupID);
      if (data) {
        this.setState({
          userGroups: data.result,
        });
      }
    } else {
      this.setState({
        userGroups: this.props.userGroups,
      });
    }
  };

  getUsersList = async () => {
    const userID = this.props.userID;
    if (userID) {
      this.setState({ isLoading: true });
    }

    const data = await getUsers(userID);

    if (data) {
      this.setState({
        users: data,
        totalRecords: data.length,
        isLoading: false,
      });
    }
    this.setState({ loading: false });
  };

  getRequestedUsersAccount = async () => {
    const userID = this.props.userID;
    if (userID) {
      this.setState({ isLoading: true });
    }
    const data = await getRequestedUsers(userID);

    if (data) {
      this.setState({
        requestedAccount: data,
        requestedAccountNb: data.length,
        isLoading: false,
      });
    }
    this.setState({ loading: false });
  };

  deleteUser = async () => {
    const id = this.state.userID;

    if (!id) {
      return;
    }

    try {
      let url = link + `deleteUser&id=${id}`;

      const response = await fetch(url, {
        method: "DELETE",
        credentials: "include",
        headers: {
          Accept: "*/*",
        },
      });
      const data = await response.json();
      if (data.status === 200) {
        this.getUsersList();
        this.toast.show({
          severity: "success",
          detail: "User has been successfully deleted.",
          life: 2000,
          sticky: true,
        });
      }
    } catch (error) {
      console.log("error:", error);
    }
  };

  onSubmit = async (values, resetForm) => {
    const formData = JSON.stringify({ formData: values });

    const email = values["email"];
    const userID = values["userID"];
    this.setState({
      isSubmitting: true,
      blocked: true,
      isSubmittingMsg: "Saving...",
    });
    try {
      const response = await fetch(link + "register", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json, text/plain, */*",
        },
        body: formData,
      });

      const data = await response.json();

      let msg =
        data.status === 200
          ? userID !== 0
            ? "The user has been updated successfully"
            : `The user has been saved successfully \n and an email has been sent to ${email}.`
          : data.result
          ? data.result
          : "Failed to save User.";

      this.setState({ isSubmittingMsg: msg });
      this.getUsersList();

      await new Promise((resolve) => setTimeout(resolve, 2000));
      
      this.setState({
        isSubmitting: false,
        blocked: false,
        isSubmittingMsg: "",
      });

      if (userID === 0) {
        resetForm();
        $(".togglable-section").toggleClass("h");
      }
      
     
    } catch (error) {
      console.error("Error:", error);
    }
  };

  confirmReject(e) {
    e.preventDefault();
    confirmDialog({
      message:
        "Do you want to reject this user account request? Please note that the user request will be deleted.",
      header: "Decline user account request",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => this.saveAccountRequest(e, "reject"),
      reject: () => false,
    });
  }

  handleAccountRequestOnclick = (data) => {
    if (data) {
      data["createdBy"] = this.props.userID;
      data["userID"] = 0;
      data["action"] = 0;
      this.setState({ visible: true, userRequestData: data });
    }
  };

  requestedUserAction = (data) => {
    return (
      <button
        className="bcb-btn requested-btn"
        onClick={() => this.handleAccountRequestOnclick(data)}
      >
        <i
          className="pi pi-user"
          style={{ color: "#fff", fontSize: ".7rem", marginRight: "5px" }}
        ></i>{" "}
        Requested
      </button>
    );
  };

  saveAccountRequest = (e, flag) => {
    e.preventDefault();

    if (flag === "accept") {
      this.setState({ blocked: true });
    }

    let data = this.state.userRequestData;
    data["action"] = flag;
    const formData = JSON.stringify({ formData: this.state.userRequestData });

    fetch(link + "saveAccountRequest", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json, text/plain, */*",
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          let msg =
            flag === "reject"
              ? "User request rejected successfully."
              : "User request accepted successfully.";

          this.msgs1.show([
            { severity: "success", summary: "", detail: msg, sticky: true },
          ]);
          setTimeout(() => {
            this.msgs1.clear();
            this.setState({ visible: false });
          }, 1000);
          // this.showStatusMsg(true, msg);
          this.setState({ blocked: true });
        } else {
          // this.showStatusMsg(true, "Failed to save User.");
          this.msgs1.show([
            {
              severity: "danger",
              summary: "",
              detail: "Failed to save User.",
              sticky: true,
            },
          ]);
          setTimeout(() => {
            this.msgs1.clear();
            this.setState({ visible: false });
          }, 1000);
        }

        this.getRequestedUsersAccount();
        this.getUsersList();
        this.setState({ blocked: false });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  render() {
    const { Formik } = formik;
    const countries = this.props.countries;
    const userGroups = this.props.userGroups;
    const titles = this.props.titles;
    const markets = this.props.markets;
    const hotels = this.props.hotels;


    const paginatorLeft = (
      <Button type="button" icon="pi pi-refresh" className="p-button-text" />
    );
    const tableHeader = (
      <RenderTableHeader
        clearFilterDatatable={this.clearFilterDatatable}
        globalFilterValue={this.state.globalFilterValue}
        onGlobalFilterChange={this.onGlobalFilterChange}
      />
    );

    const schema = yup.object().shape({
      title: yup
        .string()
        .required(<T value={"Title is required"} />)
        .notOneOf(["0"], <T value={"Title is required"} />),
      userType: yup
        .number()
        .required(<T value={"User Type is required"} />)
        .notOneOf([0], <T value={"User Type is required"} />),
      // hotel: yup
      //   .string()
      //   .required(<T value={"Hotel is required"} />)
      //   .notOneOf([0], <T value={"Hotel is required"} />),
      market: yup
        .string()
        .required(<T value={"Market is required"} />)
        .notOneOf([0], <T value={"Market is required"} />),
      firstname: yup.string().required(<T value={"First Name is required"} />),
      lastname: yup.string().required(<T value={"Last Name is required"} />),
      email: yup.string().required(<T value={"Email is required"} />),
      address: yup.string().optional(),

      dateOfBirth: yup
        .string()
        .required(<T value={"Date of Birth is required"} />),
      country: yup
        .string()
        .required(<T value={"Country is required"} />)
        .notOneOf([0], <T value={"Country is required"} />),
      company: yup.string().required(<T value={"company is required"} />),
      telephone: yup.string().required(<T value={"Telephone is required"} />),
      unsuscribe: yup.boolean().optional(),
    });

    return (
      <BlockUI
        blocked={this.state.blockedPanel}
        template={<span className="saving-block">Saving... </span>}
      >
        <div>
          <div className="sticky-top">
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>
          <div className="main-content">
            <div className="users-table">
              <AnimatePresence mode="wait">
                <motion.div
                  // key={!isOpen ? "SubscriptionPlan" : "CheckOut"}
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: -20, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <div
                    id="Add-new-user-section"
                    className="togglable-section h"
                  >
                    <div className="b2b-form">
                      <BlockUI
                        blocked={this.state.blocked}
                        template={
                          <span
                            style={{ color: "#fff" }}
                            className="saving-block"
                          >
                            {this.state.isSubmittingMsg}
                          </span>
                        }
                      >
                        <Formik
                          validationSchema={schema}
                          onSubmit={(values, { resetForm }) =>{
                            this.onSubmit(values, resetForm)
                           
                          }
                           
                          }
                          initialValues={this.state.initialValues}
                          enableReinitialize={true}
                        >
                          {({
                            handleSubmit,
                            handleChange,

                            values,
                            touched,
                            errors,
                            handleBlur,
                            isSubmitting,
                          }) => (
                            <Form
                              noValidate
                              onSubmit={handleSubmit}
                              className="p-4"
                            >
                              <Row className="g-3 ">
                                <Form.Group as={Col} md="4" controlId="">
                                  <FloatingLabel
                                    label={<T value={"User type"} />}
                                    className=""
                                  >
                                    <Form.Select
                                      aria-label=""
                                      name="userType"
                                      className="custom-input"
                                      placeholder="Select userType"
                                      value={values.userType}
                                      onChange={handleChange}
                                      isInvalid={!!errors.userType}
                                    >
                                      <option key={0} value={0}>
                                        {"Select user Type"}
                                      </option>
                                      {this.state.userGroups.map(
                                        (userGroup, index) => {
                                          return (
                                            <option
                                              key={index}
                                              value={userGroup.userGroupID}
                                            >
                                              {userGroup.userGroup}
                                            </option>
                                          );
                                        }
                                      )}
                                    </Form.Select>
                                    <ErrorMessage
                                      name="type"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FloatingLabel>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="">
                                  <FloatingLabel
                                    label={<T value={"Market"} />}
                                    className=""
                                  >
                                    <Form.Select
                                      aria-label=""
                                      name="market"
                                      className="custom-input"
                                      placeholder={
                                        <T value={"Select a Market"} />
                                      }
                                      value={values.market}
                                      onChange={handleChange}
                                      isInvalid={!!errors.market}
                                    >
                                      <option key={0} value={0}>
                                        {"Select market"}
                                      </option>
                                      {markets.map((market, index) => {
                                        return (
                                          <option
                                            key={index + 1}
                                            value={market.marketID}
                                          >
                                            {market.marketName}
                                          </option>
                                        );
                                      })}
                                    </Form.Select>
                                    <ErrorMessage
                                      name="market"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FloatingLabel>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="">
                                  <FloatingLabel
                                    label={<T value={"Hotel"} />}
                                    className=""
                                  >
                                    <Form.Select
                                      aria-label=""
                                      name="hotel"
                                      className="custom-input"
                                      placeholder={
                                        <T value={"Select a Hotel"} />
                                      }
                                      value={values.hotel}
                                      onChange={handleChange}
                                      isInvalid={!!errors.hotel}
                                    >
                                      <option key={0} value={0}>
                                        {"Select hotel"}
                                      </option>
                                      {hotels.map((hotel, index) => {
                                        return (
                                          <option
                                            key={index + 1}
                                            value={hotel.hotel_id}
                                          >
                                            {hotel.hotel_name}
                                          </option>
                                        );
                                      })}
                                    </Form.Select>
                                    <ErrorMessage
                                      name="hotel"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FloatingLabel>
                                </Form.Group>
                              </Row>
                              <Row className="g-3 mb-2">
                                <Col className="col-12 col-sm-2 col-lg-2">
                                  <Form.Group controlId="">
                                    <FloatingLabel
                                      label={<T value={"Title"} />}
                                      className=""
                                    >
                                      <Form.Select
                                        aria-label=""
                                        id="title"
                                        name="title"
                                        className="custom-input"
                                        placeholder={<T value={"Title"} />}
                                        value={values.title}
                                        onChange={handleChange}
                                        isInvalid={!!errors.title}
                                      >
                                        <option key={0} value={0}>
                                          Select Title
                                        </option>
                                        {titles.map((title, index) => {
                                          return (
                                            <option
                                              key={index + 1}
                                              value={title}
                                            >
                                              {title}
                                            </option>
                                          );
                                        })}
                                      </Form.Select>
                                      <ErrorMessage
                                        name="title"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FloatingLabel>
                                  </Form.Group>
                                </Col>
                                <Col className="col-12 col-sm-10 col-lg-10">
                                  <Row className="g-3">
                                    <Form.Group as={Col} md="6">
                                      <FloatingLabel
                                        label={<T value={"First Name"} />}
                                        className=""
                                      >
                                        <Form.Control
                                          type="text"
                                          id="firstname"
                                          className="custom-input"
                                          placeholder={
                                            <T value={"First Name"} />
                                          }
                                          name="firstname"
                                          value={values.firstname}
                                          onChange={handleChange}
                                          isInvalid={!!errors.firstname}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {errors.firstname}
                                        </Form.Control.Feedback>
                                      </FloatingLabel>
                                    </Form.Group>
                                    <Form.Group as={Col} md="6">
                                      <FloatingLabel
                                        label={<T value={"Last Name"} />}
                                        className=""
                                      >
                                        <Form.Control
                                          type="text"
                                          id="lastname"
                                          className="custom-input"
                                          placeholder={
                                            <T value={"Last Name"} />
                                          }
                                          name="lastname"
                                          value={values.lastname}
                                          onChange={handleChange}
                                          isInvalid={!!errors.lastname}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {errors.lastname}
                                        </Form.Control.Feedback>
                                      </FloatingLabel>
                                    </Form.Group>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="g-3 mb-2">
                                <Form.Group as={Col} md="6">
                                  <FloatingLabel
                                    label={<T value={"Date of birth"} />}
                                    className=""
                                  >
                                    <Form.Control
                                      type="date"
                                      id="dateOfBirth"
                                      className="custom-input"
                                      placeholder=""
                                      name="dateOfBirth"
                                      value={values.dateOfBirth}
                                      onChange={handleChange}
                                      isInvalid={!!errors.dateOfBirth}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.dateOfBirth}
                                    </Form.Control.Feedback>
                                  </FloatingLabel>
                                </Form.Group>
                                <Form.Group as={Col} md="6">
                                  <FloatingLabel
                                    label={<T value={"Email"} />}
                                    className=""
                                  >
                                    <Form.Control
                                      type="email"
                                      id="email"
                                      className="custom-input"
                                      placeholder={<T value={"Email"} />}
                                      name="email"
                                      value={values.email}
                                      onChange={handleChange}
                                      isInvalid={!!errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.email}
                                    </Form.Control.Feedback>
                                  </FloatingLabel>
                                </Form.Group>
                              </Row>
                              <Row className="g-3 mb-2">
                                <Form.Group>
                                  <FloatingLabel
                                    label={<T value={"Address"} />}
                                    className=""
                                  >
                                    <Form.Control
                                      as="textarea"
                                      rows={5}
                                      id="address"
                                      name="address"
                                      value={values.address}
                                      onChange={handleChange}
                                      isInvalid={!!errors.address}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.email}
                                    </Form.Control.Feedback>
                                  </FloatingLabel>
                                </Form.Group>
                              </Row>

                              <Row className="g-3 mb-2">
                                <Form.Group as={Col} md="6">
                                  <FloatingLabel
                                    label={<T value={"Company"} />}
                                    className=""
                                  >
                                    <Form.Control
                                      type="text"
                                      id="company"
                                      className="custom-input"
                                      placeholder=""
                                      name="company"
                                      value={values.company}
                                      onChange={handleChange}
                                      isInvalid={!!errors.company}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.email}
                                    </Form.Control.Feedback>
                                  </FloatingLabel>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="">
                                  <FloatingLabel
                                    label={<T value={"Country"} />}
                                    className=""
                                  >
                                    <Form.Select
                                      aria-label=""
                                      name="country"
                                      className="custom-input"
                                      placeholder={
                                        <T value={"Select country"} />
                                      }
                                      value={values.country}
                                      onChange={handleChange}
                                      isInvalid={!!errors.country}
                                    >
                                      <option key={0} value={0}>
                                        {"Select country"}
                                      </option>
                                      {countries.map((country, index) => {
                                        return (
                                          <option
                                            key={index + 1}
                                            value={country.id}
                                          >
                                            {country.description}
                                          </option>
                                        );
                                      })}
                                    </Form.Select>
                                    <ErrorMessage
                                      name="country"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FloatingLabel>
                                </Form.Group>
                              </Row>

                              <Row className="g-3 ">
                                <Form.Group as={Col} md="4">
                                  <FloatingLabel
                                    label={<T value={"Telephone"} />}
                                    className=""
                                  >
                                    <Form.Control
                                      type="text"
                                      id="telephone"
                                      className="custom-input"
                                      placeholder={<T value={"Telephone"} />}
                                      name="telephone"
                                      value={values.telephone}
                                      onChange={handleChange}
                                      isInvalid={!!errors.telephone}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.country}
                                    </Form.Control.Feedback>
                                  </FloatingLabel>
                                </Form.Group>
                                <Form.Group as={Col} md="4">
                                  <FloatingLabel
                                    label={<T value={"Mobile"} />}
                                    className=""
                                  >
                                    <Form.Control
                                      type="text"
                                      id="mobile"
                                      className="custom-input"
                                      placeholder={<T value={"Mobile"} />}
                                      name="mobile"
                                      value={values.mobile}
                                      onChange={handleChange}
                                      isInvalid={!!errors.mobile}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.mobile}
                                    </Form.Control.Feedback>
                                  </FloatingLabel>
                                </Form.Group>
                                <Form.Group as={Col} md="4">
                                  <FloatingLabel
                                    label={<T value={"Fax"} />}
                                    className=""
                                  >
                                    <Form.Control
                                      type="text"
                                      id="fax"
                                      placeholder={<T value={"Fax"} />}
                                      name="fax"
                                      className="custom-input"
                                      value={values.fax}
                                      onChange={handleChange}
                                      isInvalid={!!errors.fax}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.fax}
                                    </Form.Control.Feedback>
                                  </FloatingLabel>
                                </Form.Group>
                              </Row>
                              <div>
                                <input
                                  type="checkbox"
                                  id="unsuscribe"
                                  name="unsuscribe"
                                  checked={values.unsuscribe}
                                  onChange={handleChange}
                                  className="me-3"
                                />
                                <label htmlFor="unsuscribe">
                                  I want to receive notification emails
                                  <span className=""> </span>
                                </label>
                              </div>
                              <Toast
                                ref={(el) => (this.toast = el)}
                                position="top-right"
                              />
                              <div className="row justify-content-center mt-3">
                                <button
                                  type="submit"
                                  disabled={this.state.isSubmitting}
                                  className="col-12 col-sm-2 col-lg-2  btn  bcb-btn-primary bcb-btn-small text-capitalize "
                                >
                                  {<T value={"Save"} />}{" "}
                                </button>
                                <button
                                  type="reset"
                                  onClick={(e) => this.toggleForm(e)}
                                  className="col-12 col-sm-2 col-lg-2 mx-4 btn  bcb-btn-secondary bcb-btn-small text-capitalize "
                                >
                                  {<T value={"Close"} />}{" "}
                                </button>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </BlockUI>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>

              <div className="togglable-section">
                <div className="row" id="new-user-block">
                  <div className="col">
                    <hr />
                  </div>
                  <div className="col col-auto ">
                    <button
                      id="add-user"
                      className="col-12 btn bcb-btn-primary bcb-btn-smaller bcb-btn text-uppercase"
                      onClick={(e) => this.toggleForm(e)}
                    >
                      <i className="bi bi-person-plus"></i>{" "}
                      {<T value={"New User"} />}
                    </button>
                  </div>
                </div>

                {/* The above code is creating a DataTable component in a React application. The DataTable
              is displaying a list of users with columns for user ID, name, email, country,
              position, and actions.  */}

                <div className=" d-flex justify-content-end gap-2 mb-4 account-type">
                  <button
                    className={`btn bcb-btn-smaller ${
                      this.state.datatable === 1 ? "bcb-bg-primary" : " "
                    } `}
                    onClick={(e) => this.setState({ datatable: 1 })}
                  >
                    Available
                  </button>
                  <button
                    className={`btn bcb-btn-smaller ${
                      this.state.datatable === 2 ? "bcb-bg-primary" : " "
                    }`}
                    onClick={(e) => this.setState({ datatable: 2 })}
                  >
                    <i
                      className="pi pi-users"
                      style={{ fontSize: "1rem", marginRight: "3px" }}
                    ></i>{" "}
                    Requested
                    <Badge
                      value={this.state.requestedAccountNb}
                      severity="success"
                      className="account-type-badge"
                      style={{ backgroundColor: "#31c947", marginLeft: "5px" }}
                    ></Badge>
                  </button>
                </div>

                <Dialog
                  header="User Account Request"
                  visible={this.state.visible}
                  style={{ width: "50vw", left: "5rem" }}
                  onHide={() => {
                    if (!this.state.visible) return;
                    this.setState({ visible: false });
                  }}
                >
                  <div className="content">
                    <Messages ref={(el) => (this.msgs1 = el)} />
                    <div className="email-body">
                      <BlockUI
                        blocked={this.state.blocked}
                        template={
                          <span style={{ color: "#fff" }}>Saving...</span>
                        }
                      >
                        <table className="user-details">
                          <caption className="sticky-top p-x-2">
                            <h6>USER DETAILS:</h6>
                          </caption>
                          {this.state.userRequestData ? (
                            <tbody>
                              <tr>
                                <th>Title</th>
                                <td>{this.state.userRequestData.userTitle}</td>
                              </tr>

                              <tr>
                                <th>First name</th>
                                <td>
                                  {this.state.userRequestData.userOthername}
                                </td>
                              </tr>

                              <tr>
                                <th>Last name</th>
                                <td>
                                  {this.state.userRequestData.userSurname}
                                </td>
                              </tr>
                              <tr>
                                <th>Date of Birth</th>
                                <td>{this.state.userRequestData.userDOB}</td>
                              </tr>

                              <tr>
                                <th>Gender</th>
                                <td>{this.state.userRequestData.userGender}</td>
                              </tr>

                              <tr>
                                <th>User Group</th>
                                <td>{this.state.userRequestData.userGroup}</td>
                              </tr>
                              <tr>
                                <th>Market</th>
                                <td>{this.state.userRequestData.market}</td>
                              </tr>
                              <tr>
                                <th>Company</th>
                                <td>
                                  {this.state.userRequestData.userCompany}
                                </td>
                              </tr>
                              <tr>
                                <th>Email Address</th>
                                <td>
                                  <a
                                    href={`mailto:${this.state.userRequestData.userEmail}`}
                                  >
                                    {this.state.userRequestData.userEmail}
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <th>Address</th>
                                <td>
                                  {this.state.userRequestData.userAddress}
                                </td>
                              </tr>
                              <tr>
                                <th>Country</th>
                                <td>
                                  {this.state.userRequestData.userCountry}
                                </td>
                              </tr>
                              <tr>
                                <th>Telephone Number</th>
                                <td> {this.state.userRequestData.userPhone}</td>
                              </tr>
                              <tr>
                                <th>Mobile Number</th>
                                <td>
                                  {" "}
                                  {this.state.userRequestData.userMobile}
                                </td>
                              </tr>
                              <tr>
                                <th>Fax Number</th>
                                <td>{this.state.userRequestData.userFax}</td>
                              </tr>
                            </tbody>
                          ) : null}
                        </table>
                      </BlockUI>
                      <div className="sticky-bottom ">
                        <div className=" d-flex justify-content-center  gap-4 user-account-request-action">
                          <button
                            className="btn bcb-btn bcb-btn-primary text-uppercase bcb-btn-small "
                            onClick={(e) =>
                              this.saveAccountRequest(e, "accept")
                            }
                          >
                            <T value={"Accept"} />
                          </button>
                          <button
                            className="btn bcb-btn bcb-btn-secondary  text-uppercase bcb-btn-small mx-3"
                            onClick={(e) => this.confirmReject(e)}
                          >
                            <T value={"Decline"} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Dialog>

                <div className="">
                  {this.state.datatable === 1 ? (
                    !this.state.isLoading ? (
                      <DataTable
                        value={this.state.users}
                        size={"small"}
                        header={tableHeader}
                        paginator
                        emptyMessage={<T value={"No users found"} />}
                        paginatorLeft={paginatorLeft}
                        loading={this.state.loading}
                        totalRecords={this.state.totalRecords}
                        stripedRows
                        stateStorage="local"
                        stateKey="users"
                        paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rows={10}
                        rowsPerPageOptions={[10, 20, 50]}
                        globalFilterFields={[
                          "userGroup",
                          "userOthername",
                          "userSurname",
                          "userCountry",
                          "userCreatedDate",
                        ]}
                        filters={this.state.filters}
                        filterDisplay="menu"
                      >
                        <Column
                          field="userID"
                          header="#"
                          body={rowIndex}
                          sortable
                        ></Column>
                        <Column
                          field="userOthername"
                          body={(data) =>
                            data["userOthername"] + " " + data["userSurname"]
                          }
                          sortable
                          header={<T value={"Name"} />}
                        >
                          {" "}
                        </Column>
                        <Column
                          field="userEmail"
                          header={<T value={"email"} />}
                        ></Column>
                        <Column
                          field="userCountry"
                          sortable
                          header={<T value={"Country"} />}
                        ></Column>
                        <Column
                          field="userGroup"
                          sortable
                          header={<T value={"Position"} />}
                        ></Column>
                        <Column
                          field="userCreatedByName"
                          sortable
                          header={<T value={"Created By"} />}
                        ></Column>
                        <Column
                          field="userCreatedDate"
                          sortable
                          header={<T value={"Created on"} />}
                        ></Column>
                        <Column
                          field="userID"
                          header="Actions"
                          body={this.onActionBtn}
                        ></Column>
                      </DataTable>
                    ) : (
                      <UserSkeleton />
                    )
                  ) : !this.state.isLoading ? (
                    <DataTable
                      value={this.state.requestedAccount}
                      size={"small"}
                      sortField="userRequestID"
                      sortOrder={-1}
                      // resizableColumns
                      paginator
                      emptyMessage={
                        <T value={"No New Account requested found"} />
                      }
                      paginatorLeft={paginatorLeft}
                      loading={this.state.loading}
                      stripedRows
                      stateStorage="local"
                      stateKey="account_request"
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={10}
                      rowsPerPageOptions={[10, 20, 50]}
                    >
                      <Column
                        field="userRequestID"
                        header="#"
                        body={rowIndex}
                        sortable
                      ></Column>
                      <Column
                        field="userOthername"
                        body={(data) =>
                          data["userOthername"] + " " + data["userSurname"]
                        }
                        sortable
                        header={<T value={"Name"} />}
                      >
                        {" "}
                      </Column>
                      <Column
                        field="userEmail"
                        header={<T value={"email"} />}
                      ></Column>
                      <Column
                        field="userCountry"
                        sortable
                        header={<T value={"Country"} />}
                      ></Column>
                      <Column
                        field="userCompany"
                        sortable
                        header={<T value={"Company"} />}
                      ></Column>
                      <Column
                        field="createdDate"
                        sortable
                        header={<T value={"Created on"} />}
                      ></Column>
                      <Column
                        field="userRequestID"
                        header="Actions"
                        body={this.requestedUserAction}
                      ></Column>
                    </DataTable>
                  ) : (
                    <UserSkeleton />
                  )}
                </div>

                <div className=""></div>
              </div>
            </div>
          </div>
        </div>
      </BlockUI>
    );
  }
}
